module.exports = __webpack_public_path__ + "static/media/allclients.61e9992f.jpg";